import tracker from '@getvero/tracking';

export enum VeroEventName {
  FIRST_LOGIN = 'first_login',
  INVITE_TEAM = 'invite_team',
}

const isEnabled = () => typeof window !== 'undefined' && process.env.NEXT_PUBLIC_APP_ENV !== 'development';

let initialized = false;

export const initVero = (): void => {
  if (!isEnabled() || initialized) return;

  const apiKey = process.env.NEXT_PUBLIC_VERO_API_KEY;
  if (!apiKey) return;

  tracker.init({ trackingApiKey: apiKey });
  initialized = true;
};

export const identifyVeroUser = (id: string, email: string): void => {
  if (!isEnabled() || !initialized) return;
  tracker.user.identify({ id, email }).catch(() => {});
};

export const unidentifyVeroUser = (): void => {
  if (!isEnabled() || !initialized) return;
  tracker.user.unidentify();
};

export const trackVeroEvent = (
  eventName: VeroEventName,
  data?: Record<string, string | number>,
  identity?: { userId: string; email: string },
): void => {
  if (!isEnabled() || !initialized) return;
  tracker.event.track({ eventName, data, identity }).catch(() => {});
};
